// extracted by mini-css-extract-plugin
export default {"sidebarList":"SidebarList_sidebarList__mYlhY","parentElement":"SidebarList_parentElement__1jrDl"};